module.exports = "<itpx-uploader [cancelRoute]='cancelRoute' [component]='component' [saveRoute]='saveRoute' [type]=\"allowedTypes\"\n    [imgSrc]='imgSrc' [bucket]=\"bucket\" [dimensions]=\"dimensions\" [requirements]=\"requirements\">\n</itpx-uploader>"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/organization-details/organization-details-edit/update-background-image/update-background-image.component.html
// module id = ./src/app/organization/components/organization-details/organization-details-edit/update-background-image/update-background-image.component.html
// module chunks = main